<script setup>
defineProps({
  size: {
    type: String,
    default: "md",
  },
  color: {
    type: String,
    default: "success",
  },
  variant: {
    type: String,
    default: "fill",
  },
  circular: {
    type: Boolean,
    default: false,
  },
  floating: {
    type: Boolean,
    default: false,
  },
  border:{
    type: String,
    defaul: ""
  }
})


const getClasses = (variant, color, size, circular, floating, border) => {
  let colorValue, sizeValue, circleValue, floatingValue, borderValue;

  if (variant === "gradient") {
    colorValue = `badge-gradient-${color}`;
  } else {
    colorValue = `badge-${color}`;
  }

  sizeValue = size ? `badge-${size}` : null;

  circleValue = circular ? "badge-circle" : null;

  floatingValue = floating ? "badge-floating" : null;

  borderValue = border;

  return `${colorValue} ${sizeValue} ${circleValue} ${floatingValue} ${borderValue}`;
}
</script>
<template>
  <span class="badge" :class="getClasses(variant, color, size, circular, floating, border)">
    <slot />
  </span>
</template>
